import { render, staticRenderFns } from "./ListadoTareasAsignadas.vue?vue&type=template&id=ce72ada2&"
import script from "./ListadoTareasAsignadas.vue?vue&type=script&lang=js&"
export * from "./ListadoTareasAsignadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports